import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LoginPage from '../pages/Login/LoginPage';
import Sites from '../pages/Sites/Sites';
import { Header } from '../components';
import NotFound404 from '../pages/404-Not-Found/NotFound404';
import TrainingPage from '../pages/Training/TrainingPage';
import { useViewerStore } from '../store/store';
import EditorPage from '../pages/Editor/EditorPage';
import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import PrivateRoutes from './PrivateRoutes';

const AppRoutes: React.FC = () => {
    const isAzureAuthenticated = useIsAuthenticated();
    const location = useLocation();
    const navigate = useNavigate();
    const [hideHeader, setHideHeader] = useState<boolean>(false);

    useEffect(() => {
        if (location.search.includes('sfid') && !isAzureAuthenticated) {
            const urlParams = new URLSearchParams(location.search);
            const sfid = urlParams.get('sfid');
            if (sfid) sessionStorage.setItem('sfidForRedirect', sfid);
            if (location.search.includes('app=oneBUTTON')) {
                sessionStorage.setItem('app', 'oneBUTTON');
            }
        }

        if (location.pathname === '/redirect' && isAzureAuthenticated) {
            const sfidForRedirect = sessionStorage.getItem('sfidForRedirect');
            if (sfidForRedirect) {
                if (sessionStorage.getItem('app') === 'oneBUTTON') {
                    navigate(`/configure?sfid=${sfidForRedirect}&app=oneBUTTON`);
                } else {
                    navigate(`/configure?sfid=${sfidForRedirect}`);
                }
            }
            sessionStorage.removeItem('app');
            sessionStorage.removeItem('sfidForRedirect');
        }

        if (window.location.search.includes('app=oneBUTTON')) {
            setHideHeader(true);
            useViewerStore.setState({ isIframeEmbeddedInOneButton: 'true' });
        }
    }, [location, isAzureAuthenticated, navigate]);

    const isSiteRedirectNeeded =
        location.pathname === '/sites' && !!sessionStorage.getItem('sfidForRedirect');

    return (
        <>
            <AuthenticatedTemplate>{!hideHeader && <Header />}</AuthenticatedTemplate>

            <Routes>
                <Route path='/' element={<Navigate replace to='/login' />} />

                <Route
                    path='/login'
                    element={isAzureAuthenticated ? <Navigate replace to='/sites' /> : <LoginPage />}
                />

                <Route element={<PrivateRoutes />}>
                    <Route
                        path='/sites'
                        element={
                            isSiteRedirectNeeded ? <Navigate replace to='/redirect' /> : <Sites />
                        }
                    />
                    <Route
                        path='/redirect'
                        element={isAzureAuthenticated ? <Navigate replace to='/sites' /> : <LoginPage />}
                    />
                    <Route path='/training' element={<TrainingPage />} />
                    <Route path='/configure' element={<EditorPage />} />

                    {!location.pathname.includes('/redirect') && (
                        <Route path='*' element={<NotFound404 />} />
                    )}
                </Route>
            </Routes>
        </>
    );
};

export default AppRoutes;
